module.exports = __webpack_public_path__ + "img/early-warning-armed.1b95beaf.svg";